import { createFileRoute, redirect } from "@tanstack/react-router";
import { SETTINGS_REDIRECTS } from "@/features/settings/sections";

/** Old URL (ALP-84 P4): calendar settings are the Calendar section of Settings → General; my calendar notifications are under Notifications. */
export const Route = createFileRoute("/_app/settings/calendar")({
  beforeLoad: () => {
    throw redirect({ ...SETTINGS_REDIRECTS["/settings/calendar"], replace: true });
  },
});
